.root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--color-surface-subtle);
}

.card {
  max-width: 560px;
  width: 100%;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.icon {
  font-size: 28px;
  color: var(--color-warning);
}

.title {
  font-size: 19px;
  font-weight: 700;
  color: var(--color-text);
}

.subtitle {
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.6;
}

.subtitle code {
  background: var(--color-surface-sunken);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 1px 5px;
  font-family: var(--font-mono);
  font-size: 0.92em;
}

.list {
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 12px;
  border-radius: var(--radius-md);
  background: var(--color-warning-soft);
  border: 1px solid rgba(165, 104, 15, 0.18);
  font-size: 13px;
  color: var(--color-text);
}

.key {
  font-family: var(--font-mono);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--color-warning);
}
